let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("1SX98")).then(() => parcelRequire('aM2eo'));